﻿import Overlay from 'ol/Overlay.js';

let vxOlMap;
class vxOverlay {
    static onGenericClick(evt, callbackfunction) {
        const coordinate = evt.coordinate;
        // Pulisce contenuto precedente
        vxOlMap.overlayContent.textContent='';

        let findFeature = false;

        const selected = [];
        vxOlMap.map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
            //console.log(JSON.safeStringify(feature));
            const layername = layer.getProperties().name
            const featureid = feature.getProperties().id;
            const selIndex = selected.indexOf(layername + featureid);
            //console.log(JSON.safeStringify(layer.getProperties().name));
            if (selIndex < 0) {
                //console.log(JSON.safeStringify(layer.getProperties().name + " id: " + feature.getProperties().id + " index: " + selIndex));
                selected.push(layername + featureid);
                vxOlMap.overlayContent.appendChild(callbackfunction(feature, layername));
                findFeature = true;
            }
        });
        if (findFeature) {
            vxOlMap.overlay.setPosition(coordinate);
        }
        else {
            //nasconde overlay se position is 'undefined'
            vxOlMap.overlay.setPosition(undefined);
        }
    }

    static createOverlay(myVxOlMap) {
        vxOlMap = myVxOlMap;
        //OVERLAY
        /**
         * Elements that make up the popup.
         */
        vxOlMap.overlayContainer = document.getElementById('popup');
        vxOlMap.overlayContent = document.getElementById('popup-content');
        vxOlMap.overlayCloser = document.getElementById('popup-closer');

        /**
         * Create an overlay to anchor the popup to the map.
         */
        vxOlMap.overlay = new Overlay({
            element: vxOlMap.overlayContainer,
            autoPan: {
                animation: {
                    duration: 250,
                },
            },
        });

        /**
         * Add a click handler to hide the popup.
         * @return {boolean} Don't follow the href.
         */
        vxOlMap.overlayCloser.onclick = function () {
            vxOlMap.overlay.setPosition(undefined);
            vxOlMap.overlayCloser.blur();
            return false;
        };


        //vxOlMap.overlayCloser = closer;
        //vxOlMap.overlayContent = content;
        return vxOlMap.overlay;
    }
}

export default vxOverlay;